import { Box } from "@govlaunch/web";
import React from "react";
import BundleCardForegroundIcon from "~/components/icons/Collections/BundleCardForegroundIcon";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";

interface IBundleCardForegroundProps {
  viewMode: ICardViewMode;
  color?: string;
}

export default function BundleCardForeground({ viewMode, color = "blue.600" }: IBundleCardForegroundProps) {
  return (
    <Box position="absolute" top={0} left={0} color={color}>
      <BundleCardForegroundIcon height={viewMode === ICardViewMode.Bundles ? "136px" : "116px"} width="550px" />
    </Box>
  );
}
